import { resolve, ImResponse, doorClient } from '.';

export function createTask(body: Omit<Remind.BasicConfig, 'taskId' | 'isDefault'>) {
  return resolve(
    doorClient.post<ImResponse<Remind.Config>>('/overseaim-hi-manager/v1/createRemindConfig', body),
  );
}

export function updateTask(body: Omit<Remind.BasicConfig, 'isDefault'>) {
  return doorClient.post('/overseaim-hi-manager/v1/updateRemindConfigProfile', body);
}

export function deleteTask(body: Pick<Remind.BasicConfig, 'taskId'>) {
  return doorClient.post('/overseaim-hi-manager/v1/deleteRemindConfig', body);
}

export function taskList() {
  return resolve(
    doorClient.get<
      ImResponse<{
        configs: Remind.Config[];
      }>
    >('/overseaim-hi-manager/v1/getRemindConfigList'),
  );
}

export function task(taskId: string | number) {
  return resolve(
    doorClient.get<ImResponse<Remind.Config>>('/overseaim-hi-manager/v1/remindConfigV2', {
      params: { taskId },
    }),
  );
}

export function config() {
  return resolve(
    doorClient.get<ImResponse<Remind.Config>>('/overseaim-hi-manager/v1/remindConfigV2'),
  );
}

export interface UpdateInsiteEnableBody
  extends Pick<Remind.BasicConfig, 'inSiteRemindEnable' | 'taskId'> {}

export function updateInsiteEnable(body: UpdateInsiteEnableBody) {
  return resolve(
    doorClient.post<ImResponse<void>>('/overseaim-hi-manager/v1/inSiteRemindEnable', body),
  );
}

export interface UpdateInsiteSceneBody extends Omit<Remind.InsiteConfig, 'inSiteRemindEnable'> {}

export function updateInsiteScene(body: UpdateInsiteSceneBody) {
  return resolve(
    doorClient.post<ImResponse<void>>('/overseaim-hi-manager/v1/remindSceneConfigV2', body),
  );
}

export interface UpdateOutsiteBody extends Remind.OutsiteConfig {}

export function updateOutsite(body: UpdateOutsiteBody) {
  return resolve(
    doorClient.post<ImResponse<void>>('/overseaim-hi-manager/v1/outSiteRemindConfig', body),
  );
}

export interface UpdateDingTalkBody extends Remind.DingTalkConfig {
  type: Remind.OutsiteType;
  taskId: Remind.BasicConfig['taskId'];
}

export function updateDingTalk(body: UpdateDingTalkBody) {
  return resolve(
    doorClient.post<ImResponse<void>>('/overseaim-hi-manager/v1/dingtalkConfig', body),
  );
}

export interface DeleteDingTalkParams {
  taskId: string | number;
  type: Remind.OutsiteType;
}

export function deleteDingTalk(params: DeleteDingTalkParams) {
  return doorClient.delete('/overseaim-hi-manager/v1/dingtalkConfig', { params });
}

export function sceneList() {
  return resolve(
    doorClient.get<ImResponse<{ remindScenes: Remind.SceneInfo[] }>>(
      '/overseaim-hi-manager/v1/remindScene',
    ),
  );
}

export interface ProfileRecordBody extends Remind.ProfileFilter {}

export function profileRecord(body: ProfileRecordBody) {
  return resolve(
    doorClient.post<ImResponse<{ remindReportRecord: Remind.ProfileRecord[] }>>(
      '/overseaim-hi-manager/v1/queryRemindReport',
      body,
    ),
  );
}

export interface DetailRecordBody extends Remind.DetailFilter {}

export interface DetailRecordResponse {
  pageInfo: {
    pageNo: number;
    pageSize: number;
    totalCount: number;
  };
  remindRecord: Remind.DetailRecord[];
}

export function detailRecord(body: DetailRecordBody) {
  return resolve(
    doorClient.post<ImResponse<DetailRecordResponse>>(
      '/overseaim-hi-manager/v1/queryRemindRecord',
      body,
    ),
  );
}
